module.exports = require('./isRelativeUrl')
